export default __webpack_public_path__ + "static/media/structures.a9f95d1b.png";